<i class="fas fa-heart nav-fav-icon" 
  (click)="displaySideBar()" 
  (mouseover)="FavPropertiesCountInfor.show($event)" 
  (mouseout)="FavPropertiesCountInfor.hide($event)"></i>
<p-sidebar 
  [(visible)]="showSideBar" 
  appendTo="body" 
  position="right" 
  styleClass="fav-sidebar"
  blockScroll="true">
    <div class="fav-sidebar-header">
      <span class="fav-sidebar-header-label">Favorite Properties</span>
      <span class="fav-sidebar-header-value">{{MyFavoritePropertiesCount}} out of {{UserFavoritePropertiesMaxCount}} properties set</span>
    </div>
    <div *ngIf="!loading && favoriteLoans.length === 0" class="empty-fav-prop">No favorite properties found</div>
    <p-table styleClass="fav-prop-table" [value]="favoriteLoans" dataKey="propertyId" [loading]="loading" [scrollable]="true" [resizableColumns]="true" scrollHeight="96vh">
      <ng-template pTemplate="body" let-favoriteLoan>          
        <tr>
          <td>
            <p-card>
              <div class="p-grid fav-header-template">
                <div class="fav-disp-icon">
                  <fa-icon icon="home"></fa-icon>
                </div>
                <div class="p-col fav-header-info">
                  <div class="p-grid p-justify-between">
                    <div class="p-col-9 fav-property-search-address">
                      <div class="fav-property-search-address-main">
                        {{favoriteLoan.Address.Address1}}
                        <span class="fav-icon-left">
                          <i #favIconEl
                            [attr.data-fav-loan-icon-id]="'fav-loan-' + favoriteLoan.PropertyId" 
                            [attr.data-fav-loan-flag]="favoriteLoan.IsFavorite"
                            [ngClass]="getFavIconClass(favoriteLoan.IsFavorite)" 
                            (click)="updateFavorite(favIconEl, favoriteLoan.PropertyId)">
                          </i>
                        </span>
                      </div>
                      <div class="fav-address-2">{{favoriteLoan.Address.City}}, {{favoriteLoan.Address.State}} {{favoriteLoan.Address.PostalCode}}</div>                         
                    </div>
                    <div [ngClass]="getDispStrategyClass(favoriteLoan.DispositionStrategyGroup.toUpperCase())">
                      {{favoriteLoan.DispositionStrategyGroup.toUpperCase()}}
                    </div>
                  </div>
                  <br/>
                  <div class="p-grid">
                      <div class="p-col-6">
                        <span class="fav-property-search-label">Loan Number</span><br/>
                        <span class="fav-property-search-values">
                          <a href="{{getPropertyViewUri(favoriteLoan.PropertyId)}}">{{favoriteLoan.LoanNumber}}</a>
                          <a href="{{getPropertyViewUri(favoriteLoan.PropertyId)}}" target="_blank">
                            <i class="pi pi-external-link fav-new-window-link"></i>
                          </a>
                        </span>                          
                      </div>
                      <div class="p-col-5">
                        <span class="fav-property-search-label">{{statusLabel(favoriteLoan.StatusLabel,favoriteLoan.SubStatusLabel)}}</span><br/>
                        <span class="fav-property-status-values">{{statusDisplayValue(favoriteLoan.StatusLabel,favoriteLoan.SubStatusLabel)}}</span>
                      </div>
                    </div>
                </div>
              </div>
            </p-card>
          </td>
        </tr>
      </ng-template>        
    </p-table>
</p-sidebar>
<p-overlayPanel #FavPropertiesCountInfor class="no-Flicker" [dismissable]="true">
  {{MyFavoritePropertiesCount}} out of {{UserFavoritePropertiesMaxCount}} properties
</p-overlayPanel>
<p-dialog 
  [(visible)]="displayErrorMessageDialog" 
  styleClass="messageDialog"
  [modal]="true"
  [closeOnEscape]="true"
  [contentStyle]="{'font-size':'11pt', 'min-width': '200px'}">
    <p-header class="message-header">Maximum limit reached &nbsp;<i class="fas fa-exclamation-triangle"></i></p-header>
    Your have reached the maximum limit of {{UserFavoritePropertiesMaxCount}} favorite properties. <br> 
    Please click <a href="##" (click)="displaySideBar()" class="edit-property-link">here</a> to edit your favorite properties.
</p-dialog>